module.exports = __webpack_public_path__ + "img/49.23f69b21.jpg";